import React, { useCallback, useState } from 'react';
import NewTable from '../../../components/common/NewTable';
import { pricingListColumns } from './utils';
import { useTranslation } from 'react-i18next';
import CommonRequestPage from './components/CommonRequestPage';

const RejectedRequest = () => {
  const pageType = 'approved';
  const { t } = useTranslation();
  const [rejectedRequests, setRejectedRequests] = useState([]);

  const onActionClick = useCallback((option, id) => {
    console.log(option, id);
  });

  return (
    // <>
    //   <div
    //     className="fw-medium fs-4 mb-3"
    //     style={{ color: 'rgba(68, 68, 68, 1)' }}
    //   >
    //     {t('Rejected Price Change Request')}
    //   </div>
    //   <NewTable
    //     id="PricingRejectedTable"
    //     data={rejectedRequests}
    //     columns={pricingListColumns(pageType, onActionClick)}
    //     isNewEmptyTable={true}
    //   />
    // </>
    <CommonRequestPage
      pageType={'rejected'}
      pageTitle={'Rejected Price Change Request'}
      key={'RejectedRequest'}
    />
  );
};

export default RejectedRequest;
